<template>
  <div>
    <h2 class="page-title-bar">
      <i class="ico ico-store"></i>{{ $t('Wifi Config') }}
    </h2>
    <v-row class="mt-10">
      <v-col cols="3">
        <v-text-field
          v-model="searchBy.storeNameCode"
          @keyup="searchStores(searchBy.storeNameCode)"
          @click:clear="clearStoreNameCode"
          :label="$t('Store List')"
          :placeholder="$t('Input store name or code')"
          class="form-input"
          outlined
          dense
          hide-details
          clearable
        ></v-text-field>
        <v-data-table
          v-model="selectedStores"
          @click:row="selectStore"
          :headers="storeHeaders"
          :items="stores"
          :item-class="getRowClass"
          :hide-default-footer="true"
          :items-per-page="-1"
          class="tbl-type01 style01 grayline mt-5"
          item-key="code"
          fixed-header
          height="815"
        >
          <template slot="no-data">
            <p>{{ $t('No data available') }}</p>
          </template>
        </v-data-table>
      </v-col>
      <v-col cols="1" class="d-flex justify-center align-center">
        <img src="@/assets/img/ico-next-step.png" alt="" />
      </v-col>
      <v-col cols="8">
        <div class="layout_whitelist">
          <v-data-table
                v-model="selectedWifiConfigItems"
                :headers="wifiConfigTableHeaders"
                :items="wifiConfigTableItems"
                :options.sync="options"
                :hide-default-footer="true"
                class="tbl-type01 style01 mt-5"
                item-key="id"
                fixed-header
                height="530"
              >
            <template v-slot:[`item.pwd`]="{ item }">
              <v-tooltip top content-class="v-tooltip-resize">
                <template v-slot:activator="{ on, attrs }">
                  <div
                    v-bind="attrs"
                    v-on="on"
                    @click="decryptWifiPassword(item, passwordVisibility[item.ssid] ? 'hide' : 'show')"
                    style="cursor: pointer; user-select: none;"
                  >
                    {{ passwordVisibility[item.ssid] ? item.pwd : '••••••••' }}
                  </div>
                </template>
                <span>
                  {{ passwordVisibility[item.ssid] ? 'Click to hide password' : 'Click to show password' }}
                </span>
              </v-tooltip>
            </template>

                <template slot="no-data">
                  <p> {{ $t('No data available') }} </p>
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                  <div class="d-flex">
                    <p @click.stop="!saveAddDeleteDisabled && onClickEditWifiConfig(item, passwordVisibility[item.ssid] ? 'hide' : 'show')" class="d-inline-block pointer mr-2">
                      <v-icon size="24" class=" darken-2" style="color: #001e38; cursor: pointer;">mdi-square-edit-outline</v-icon>
                    </p>
                    <p @click.stop="!saveAddDeleteDisabled && deleteWifiConfig(item)" class="d-inline-block pointer">
                      <v-icon size="24" style="cursor: pointer;" class="red--text darken-2">mdi-trash-can-outline</v-icon>
                    </p>
                  </div>
                </template>
              </v-data-table>
        </div>
        <div style="width: 100%;display: flex;align-items: center;justify-content: space-between;">
          <v-btn
            @click="onClickAddWifiConfig"
            text
            icon
            :disabled="!isStoreSelected || saveAddDeleteDisabled"
            class="btn"
            >{{ $t("Add") }}
          </v-btn>
          <Pagination @paging="paging($event)" :pageInfoText="pageInfoText" :pageIndex="pageIndex" :rowPerPage="rowPerPage"
          :totalPages="(+totalPages)" @updatePage="updatePage($event)"></Pagination>
        </div>
      </v-col>
    </v-row>
    <a ref="link" :style="{ display: 'none' }"></a>
    <v-dialog v-model="showAddWifiConfigDialog" persistent scrollable width="450">
      <v-card class="popup add_store_popup">
        <v-card-title>
          <h3 class="page-title-bar">
            <i class="ico ico-store"></i>{{ $t("Add Wifi Config") }}
          </h3>
        </v-card-title>
        <v-card-text>
          <v-text-field
            v-model="wifiConfigData.ssid"
            outlined
            dense
            hide-details
            :placeholder="`${$t('Input SSID')}`"
            class="form-input mb-2"
            :label="$t('SSID *')"
          >
          </v-text-field>
          <v-text-field
            v-model="wifiConfigData.pwd"
            outlined
            dense
            hide-details
            :placeholder="`${$t('Input Password')}`"
            class="form-input mb-2"
            :append-icon="showPwd ? 'mdi-eye-off' : 'mdi-eye'"
            :type="showPwd ? 'text' : 'password'"
            :label="$t('Password *')"
            @click:append="showPwd = !showPwd"
            @keydown.space.prevent
            @input="wifiConfigData.pwd = wifiConfigData.pwd.replace(/\s/g, '')"
          >
          </v-text-field>
          <v-text-field
            v-model="wifiConfigData.name"
            outlined
            dense
            hide-details
            :placeholder="`${$t('Input Wifi Friendly Name')}`"
            class="form-input mb-2"
            :label="$t('Wifi Friendly Name')"
          >
          </v-text-field>
        </v-card-text>
        <v-card-actions class="d-flex justify-center">
          <v-btn
            @click="addWifiConfig"
            text
            icon
            class="btn"
            :disabled="!isWifiConfigValid"
            >{{ $t("Add") }}
          </v-btn>
          <v-btn @click="showAddWifiConfigDialog=false" class="btn" text icon
            >{{ $t("Cancel") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showEditWifiConfigDialog" persistent scrollable width="450">
      <v-card class="popup add_store_popup">
        <v-card-title>
          <h3 class="page-title-bar">
            <i class="ico ico-store"></i>{{ $t("Edit Wifi Config") }}
          </h3>
        </v-card-title>
        <v-card-text>
          <v-text-field
            v-model="wifiConfigData.ssid"
            disabled
            outlined
            dense
            hide-details
            :placeholder="`${$t('Input SSID')}`"
            class="form-input mb-2"
            :label="$t('SSID *')"
          >
          </v-text-field>
          <v-text-field
            v-model="wifiConfigData.pwd"
            outlined
            dense
            hide-details
            :placeholder="`${$t('Input Password')}`"
            class="form-input mb-2"
            :append-icon="showPwd ? 'mdi-eye-off' : 'mdi-eye'"
            :type="showPwd ? 'text' : 'password'"
            :label="$t('Password *')"
            @click:append="showPwd = !showPwd"
            @keydown.space.prevent
            @input="wifiConfigData.pwd = wifiConfigData.pwd.replace(/\s/g, '')"
          ></v-text-field>
          <v-text-field
            v-model="wifiConfigData.name"
            outlined
            dense
            hide-details
            :placeholder="`${$t('Input Wifi Friendly Name')}`"
            class="form-input mb-2"
            :label="$t('Wifi Friendly Name')"
          ></v-text-field>
        </v-card-text>
        <v-card-actions class="d-flex justify-center">
          <v-btn
            @click="editWifiConfig"
            text
            icon
            class="btn"
            :disabled="!isWifiConfigValid"
            >{{ $t("Save") }}
          </v-btn>
          <v-btn @click="showEditWifiConfigDialog=false" class="btn" text icon
            >{{ $t("Cancel") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import EventBus from '@/plugins/eventBus'
import codes from '@/plugins/codes'
import commons from '@/plugins/commons'
import { setTempObj, getTempObj } from '@/plugins/sessionStorageManager'
import Pagination from '@/components/pagination/Pagination.vue'

export default {
  components: { Pagination },
  data () {
    return {
      selectedStore: null,
      requestConfig: {},
      stores: [],
      wifiConfigTableItems: [],
      selectedWifiConfigItems: [],
      selectedStores: [],
      options: null,
      totalPages: 1,
      pageInfoText: '',
      searchBy: { storeNameCode: '' },
      ROW_CLASS: 'row-class',
      saveAddDeleteDisabled: false,
      pageIndex: 1,
      wifiConfigData: {
        ssid: null,
        pwd: null,
        name: null
      },
      isEdit: false,
      showAddWifiConfigDialog: false,
      showEditWifiConfigDialog: false,
      rowPerPage: '10',
      showPwd: false,
      isStoreSelected: false,
      oldwifiConfigList: [],
      passwordVisibility: {}
    }
  },
  computed: {
    storeHeaders () {
      return [
        { text: this.$t('STORES'), align: 'center', value: 'nameCode' }
      ]
    },
    wifiConfigTableHeaders () {
      return [
        { text: '#', sortable: false, align: 'center', value: 'no' },
        { text: this.$t('NAME'), sortable: true, value: 'name' },
        { text: this.$t('SSID'), sortable: true, value: 'ssid' },
        { text: this.$t('PASSWORD'), sortable: true, value: 'pwd' },
        { text: this.$t('LAST UPDATE TIME'), sortable: true, value: 'lastModified' },
        { text: this.$t('ACTIONS'), sortable: false, value: 'actions' }
      ]
    },
    ...mapGetters({
      store: 'dataStore/GET_SELECTED_STORE'
    }),
    isWifiConfigValid () {
      return this.wifiConfigData.ssid !== null && this.wifiConfigData.ssid !== '' && this.wifiConfigData.ssid !== undefined &&
            this.wifiConfigData.pwd !== null && this.wifiConfigData.pwd !== '' && this.wifiConfigData.pwd !== undefined
    }
  },
  watch: {
    options: {
      handler () {
        if (this.selectedStore !== null && this.selectedStore !== undefined) {
          this.getWifiConfig(1, this.selectedStore.code)
        }
      },
      deep: true
    },
    store: {
      handler () {
        if (this.selectedStore) {
          this.getWifiConfig(1, this.selectedStore.code)
        }
      }
    },
    searchBy: {
      handler (newSearchBy) {
        const wifiConfigSearch = {
          searchBy: newSearchBy
        }
        setTempObj('wifiConfigSearch', wifiConfigSearch)
      },
      deep: true
    }
  },
  methods: {
    filter (evt) {
      evt = (evt) || window.event
      const expect = evt.target.value.toString() + evt.key.toString()
      if (!/^(?!(?:47806)$)(?:(6553[0-4])|(655[0-2][0-9]{1})|(65[0-4][0-9]{2})|(6[0-4][0-9]{3})|([1-5][0-9]{4})|([1-9][0-9]{3})|([1-9][0-9]{2})|([1-9][0-9]{1})|([1-9]))$/.test(expect)) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    onClickAddWifiConfig () {
      this.wifiConfigData.name = null
      this.wifiConfigData.pwd = null
      this.wifiConfigData.ssid = null
      this.showAddWifiConfigDialog = true
    },
    async onClickEditWifiConfig (wifi, flag) {
      if (flag === 'hide') {
        this.wifiConfigData.name = wifi.name
        this.wifiConfigData.ssid = wifi.ssid
        this.wifiConfigData.pwd = wifi.pwd || ''
        this.showEditWifiConfigDialog = true
        this.showPwd = false
      } else {
        try {
          this.wifiConfigData.name = wifi.name
          this.wifiConfigData.ssid = wifi.ssid
          const decryptedPwd = await this.getDecryptPassword(wifi.pwd)
          this.wifiConfigData.pwd = decryptedPwd || ''
          this.showEditWifiConfigDialog = true
          this.showPwd = false
        } catch (error) {
          console.error('Failed to load wifi config:', error)
          this.wifiConfigData.pwd = ''
          EventBus.$emit('messageAlert', this.$t('Unable to decrypt password.'))
        }
      }
    },
    addWifiConfig () {
      const body = this.wifiConfigData
      const params = {
        storeCode: this.selectedStore.code
      }
      const config = { params }
      this.$utils
        .callAxiosWithBody(
          codes.requests.addWifiConfig.method,
          codes.requests.addWifiConfig.url,
          body,
          config
        )
        .then(res => {
          if (res.status === 200) {
            EventBus.$emit('messageAlert', this.$t(res.data.responseMessage))
            this.showAddWifiConfigDialog = false
            this.paging(1)
          }
        })
        .catch(error => {
          console.log(error)
          EventBus.$emit(
            'messageAlert',
            this.$t(error.response.data.responseMessage),
            'error'
          )
          this.showAddWifiConfigDialog = false
        })
    },
    editWifiConfig () {
      const body = {
        name: this.wifiConfigData.name,
        pwd: this.wifiConfigData.pwd
      }
      const params = {
        storeCode: this.selectedStore.code,
        ssid: this.wifiConfigData.ssid
      }
      const config = { params }
      this.$utils
        .callAxiosWithBody(
          codes.requests.updateWifiConfig.method,
          codes.requests.updateWifiConfig.url,
          body,
          config
        )
        .then(res => {
          if (res.status === 200) {
            EventBus.$emit('messageAlert', this.$t(res.data.responseMessage))
            this.showEditWifiConfigDialog = false
            this.paging(1)
          }
        })
        .catch(error => {
          console.log(error)
          EventBus.$emit(
            'messageAlert',
            this.$t(error.response.data.responseMessage),
            'error'
          )
          this.showEditWifiConfigDialog = false
        })
    },
    async deleteWifiConfig (wifi) {
      const ok = await this.$confirm.open({
        title: 'Delete Confirmation',
        message: 'Are you sure you want to delete selected config?'
      })
      if (!ok) return
      const config = {
        params: {
          storeCode: this.selectedStore.code,
          ssid: wifi.ssid
        }
      }
      this.$utils
        .callAxios(
          codes.requests.deleteWifiConfig.method,
          codes.requests.deleteWifiConfig.url,
          config
        )
        .then(res => {
          if (res.status === 200) {
            EventBus.$emit('messageAlert', this.$t(res.data.responseMessage))
            this.paging(1)
          } else {
            EventBus.$emit(
              'messageAlert',
              this.$t('Something went wrong. Please try after some time.')
            )
          }
        })
        .catch(error => {
          EventBus.$emit(
            'messageAlert',
            this.$t(error.response.data.responseMessage),
            'error'
          )
        })
    },
    paging (input) {
      this.options.itemsPerPage = Number(this.rowPerPage)
      this.getWifiConfig(input, this.selectedStore.code)
    },
    updatePage (event) {
      this.rowPerPage = event.toString()
      this.paging(1)
    },
    clearTabindex () {
      var elements = document.getElementsByClassName('v-icon')
      for (let i = 0; i < elements.length; i++) {
        elements[i].setAttribute('tabindex', '-1')
      }
    },
    getPageInfoText: function (headers) {
      if (headers['x-totalelements'] === 0) return '0 to 0, 0' + ' ' + this.$t('in total')
      return `${headers['x-number'] * 1 * headers['x-size'] + 1} 
      ${this.$t('to')} ${(headers['x-number'] * 1 * headers['x-size']) + headers['x-total-count'] * 1},
       ${headers['x-totalelements'] * 1}` + ' ' + this.$t('in total')
    },
    clearWifiConfigItems () {
      this.selectedStore = null
      this.wifiConfigTableItems = []
    },
    saveRequestConfig: function (config) {
      const requestConfig = {
        url: config.url,
        method: config.method,
        params: config.params
      }
      this.requestConfig = requestConfig
    },
    insertIndex (list, headers) {
      let idx = Number(headers['x-number'] * headers['x-size']) + 1
      list = list.map(el => {
        el.no = idx
        el.lastModified = commons.convertDate(el.lastModified)
        idx++
        return el
      })
      return list
    },
    handleGetWifiConfigResponse (res) {
      if (res.status === 204) {
        this.handleGetWifiConfigError('No content', res.headers)
        return
      }
      this.saveRequestConfig(res.config)
      // Refresh articels
      this.wifiConfigTableItems = this.insertIndex(res.data.wifiConfigList, res.headers)
      this.oldwifiConfigList = JSON.parse(JSON.stringify(this.wifiConfigTableItems))
      // Pagination
      this.pageInfoText = this.getPageInfoText(res.headers)
      this.pageIndex = res.headers['x-number'] * 1 + 1
      this.totalPages = res.headers['x-totalpages']
      this.selectedWifiConfigItems = []
    },
    handleGetWifiConfigError (error, headers) {
      this.wifiConfigTableItems = []
      this.pageIndex = headers['x-number'] * 1 + 1
      this.pageInfoText = this.getPageInfoText(headers)
      this.totalPages = 0
      this.selectedWifiConfigItems = []
      console.log(error)
    },
    getWifiConfigSortKey (sortKey) {
      switch (sortKey) {
        case 'updateTime':
          sortKey = 'updateTime'
          break
        default:
          break
      }
      return sortKey
    },
    buildParmas () {
      const { sortBy, sortDesc, itemsPerPage } = this.options
      const params = { }
      let sort = null
      if (sortBy.length === 1 && sortDesc.length === 1) {
        const sortKey = this.getWifiConfigSortKey(sortBy[0])
        const sortOrder = sortDesc[0]
        sort = `${sortKey},${sortOrder ? 'desc' : 'asc'}`
      }
      if (sort !== null) params.sort = sort
      if (itemsPerPage > 0) params.size = this.rowPerPage
      return params
    },
    getWifiConfig (page, storeCode) {
      this.passwordVisibility = {}
      const params = this.buildParmas()
      params.storeCode = storeCode
      if (page !== null) params.page = page - 1
      const config = { params: params }
      this.$utils
        .callAxios(
          codes.requests.getWifiConfig.method,
          codes.requests.getWifiConfig.url,
          config
        )
        .then(res => {
          this.handleGetWifiConfigResponse(res)
          if (res.data.responseCode === '503') {
            EventBus.$emit('messageAlert', this.$t(res.data.responseMessage))
          }
        })
        .catch(error => {
          this.handleGetWifiConfigError(error, { 'x-number': 0, 'x-size': 0, 'x-total-count': 0, 'x-totalelements': 0 })
          if (error.response.data.responseCode === '503') {
            EventBus.$emit('messageAlert', this.$t(error.response.data.responseMessage))
          } else {
            // EventBus.$emit('messageAlert', this.$t('Failed to get whitelist.'))
            EventBus.$emit('messageAlert', this.$t('Please try it again later.'))
          }
        })
    },
    searchStores (storeNameCode) {
      const stores = this.$store.getters['dataStore/GET_STORE_ITEMS'].filter(store => {
        return (
          store.code.includes(storeNameCode) ||
          store.name.includes(storeNameCode)
        )
      })
      this.stores = this.addStoreNameCode(stores)
      this.clearWifiConfigItems()
    },
    addStoreNameCode (stores) {
      return stores.map(store => {
        store.nameCode = `${store.name}(${store.code})`
        return store
      })
    },

    deselectStore () {
      this.isStoreSelected = false
      this.stores.map(str => {
        str.selected = false
        return str
      })
    },
    async selectStore (store) {
      this.isStoreSelected = true
      this.stores.map(str => {
        str.selected = false
        return str
      })
      store.selected = true
      this.stores = [...this.stores]
      this.selectedStore = store
      this.getWifiConfig(1, store.code)
    },
    getRowClass (item) {
      if (item.selected) return `${this.ROW_CLASS} active`
      return this.ROW_CLASS
    },
    clearStoreNameCode () {
      this.searchBy.storeNameCode = ''
      this.searchStores(this.searchBy.storeNameCode)
    },
    decryptWifiPassword (val, flag) {
      const ssid = val.ssid
      if (flag === 'show') {
        const params = { value: val.pwd }
        const config = { params }
        this.$utils
          .callAxios(
            codes.requests.decryptWifiPassword.method,
            codes.requests.decryptWifiPassword.url,
            config
          )
          .then(res => {
            this.wifiConfigTableItems = this.wifiConfigTableItems.map(item => {
              if (item.ssid === ssid) {
                return {
                  ...item,
                  pwd: res.data.decryptedPassword
                }
              }
              return item
            })
            this.$set(this.passwordVisibility, ssid, true)
          })
          .catch(error => {
            console.error(error)
            EventBus.$emit('messageAlert', this.$t('Please try it again later.'))
          })
      } else {
        const originalItem = this.oldwifiConfigList.find(item => item.ssid === ssid)
        if (originalItem) {
          this.wifiConfigTableItems = this.wifiConfigTableItems.map(item => {
            if (item.ssid === ssid) {
              return {
                ...item,
                pwd: originalItem.pwd
              }
            }
            return item
          })
        }
        this.$set(this.passwordVisibility, ssid, false)
      }
    },
    async getDecryptPassword (val) {
      try {
        const params = { value: val }
        const config = { params }
        const res = await this.$utils.callAxios(
          codes.requests.decryptWifiPassword.method,
          codes.requests.decryptWifiPassword.url,
          config
        )
        return res.data.decryptedPassword
      } catch (error) {
        console.error(error)
        EventBus.$emit('messageAlert', this.$t('Please try it again later.'))
        return ''
      }
    }

  },
  mounted () {
    this.clearTabindex()
    EventBus.$emit('enableSelectedStores', false)
    this.$store.dispatch(
      'dataStore/UPDATE_SELECTED_STORE',
      this.$store.getters['dataStore/GET_SELECTED_STORE']
    )
    this.stores = this.addStoreNameCode(
      Object.assign([], this.$store.getters['dataStore/GET_STORE_ITEMS'])
    )
    this.$store.dispatch('auth/getDisabledBtn', '7301').then(flag => {
      this.saveAddDeleteDisabled = flag
    })
    const wifiConfigSessionData = getTempObj('wifiConfigSearch')
    if (
      !commons.isNull(wifiConfigSessionData) &&
      !commons.isNull(wifiConfigSessionData.searchBy)
    ) {
      this.searchBy = wifiConfigSessionData.searchBy
      if (!commons.isNull(this.searchBy.storeNameCode)) { this.searchStores(this.searchBy.storeNameCode) }
    }
    window.onload = () => {
      this.deselectStore()
    }
  },
  destroyed () {
    this.deselectStore()
  }
}
</script>

<style scoped>
.layout_whitelist {
  width: 100%;
  margin-top: 85px;
  border-collapse: collapse;
}
.layout_whitelist th {
  background: #ededee;
  font-weight: 400;
  color: #4d4f5c;
  font-size: 14px;
}
.layout_whitelist td {
  padding: 25px 25px 0 25px;
  vertical-align: top;
}
.layout_whitelist td.setting {
  height: 115px;
  padding-bottom: 25px;
}
.layout_whitelist tr:nth-of-type(1) th,
.layout_whitelist tr:nth-of-type(1) td {
  border-bottom: 2px solid #cfd1d7;
}
.scrollTable {
  height: calc(100% - 85px);
  overflow-y: auto;
}
.grayline {
  border: 1px solid #b7b7b7;
}
.tbl-type01 {
  word-break: break-all;
}

.tbl-type01 >>> .row-class:hover {
  cursor: pointer;
}
.tbl-type01 >>> .row-class.active {
  font-weight: 700;
}
.v-tooltip-resize {
		width: 160px;
		word-break: break-word;
    margin-left: -50px;
	}
	.v-tooltip__content {
		background: #001e38;
		color: #fff;
		padding: 5px 10px !important;
	}
	.v-tooltip__content:after {
		content: "";
		display: block;
		width: 0;
		height: 0;
		position: absolute;
		border-left: 15px solid transparent;
		border-right: 15px solid transparent;
		border-top: 15px solid #001e38;
		left: 38%;
		bottom: -10px;
	}
</style>
